module.exports = __webpack_public_path__ + "static/media/pen-solid.3063b95d.svg";